// @flow
import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import { TextField } from "formik-material-ui";
import { Field, Form, Formik } from "formik";
import { useSnackbar } from "notistack";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Box from "@material-ui/core/Box";
import type { Game } from "../../common/types";

type Props = {
  open: boolean,
  handleClose: Function,
  gameRef: any,
  game: Game,
  location: Location,
};

function GameAdminEditModal({
  open,
  handleClose,
  gameRef,
  game,
  location,
}: Props) {
  const { enqueueSnackbar } = useSnackbar();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      maxWidth="md"
    >
      <Formik
        initialValues={{
          visitorSlots: game.visitorSlots || location.visitorSlots,
          ticketReservationsClosedManually:
            game.ticketReservationsClosedManually || false,
        }}
        validationSchema={undefined}
        onSubmit={async (values) => {
          await gameRef
            .set({ ...values }, { merge: true })
            .then(() => {
              enqueueSnackbar("Gespeichert", { variant: "success" });
              handleClose();
            })
            .catch((error) => {
              console.error(error);
              enqueueSnackbar(error.message || error, { variant: "error" });
            });
        }}
      >
        {({ submitForm, isSubmitting, setFieldValue, values }) => (
          <>
            <DialogTitle id="form-dialog-title">Besucher</DialogTitle>
            <DialogContent>
              <Form style={{ width: "100%" }}>
                <Field
                  component={TextField}
                  variant="filled"
                  name="visitorSlots"
                  type="number"
                  label="Maximum an Besuchern"
                  pattern="[0-9]*"
                />
                <Box mt={0.5}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={values.ticketReservationsClosedManually}
                        onChange={() =>
                          setFieldValue(
                            "ticketReservationsClosedManually",
                            !values.ticketReservationsClosedManually
                          )
                        }
                        name="ticketReservationsClosedManually"
                      />
                    }
                    label="Als ausverkauft anzeigen"
                  />
                </Box>
              </Form>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Abbrechen
              </Button>
              <Button onClick={submitForm} color="primary">
                Speichern
              </Button>
            </DialogActions>
          </>
        )}
      </Formik>
    </Dialog>
  );
}

export default GameAdminEditModal;
